import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import Container from '../../components/Container';
import Image from '../../assets/svg/cadastroManualProdutos.svg';
import ImageMobile from '../../assets/svg/cadastroManualProdutosMobile.svg';
import Panel from '../../components/Panel';
import { gtmAttributesUpdateProductManualIntegrationPage } from '../../utils/gtmVariables';
import useGTMEventsTracker from '../../hooks/useGTMEventsTracker';
import Typography from '../../components/Typography';

const ProductManualRegistration: FC<any> = () => {
  const navigate = useNavigate();
  const gtmEventsTracker = useGTMEventsTracker();

  gtmEventsTracker(gtmAttributesUpdateProductManualIntegrationPage);

  return (
    <Container id="mp__product-manual-registration">
      <Panel
        title="Cadastro manual de produtos"
        description=""
        panelType="information"
        tooltipText={<>Você é responsável por cadastrar os produtos que a sua loja vai oferecer.</>}
        tooltipTextLink="Clique e saiba como funciona o cadastro de produtos manuais"
        tooltipLink="https://suportemarketplace.viavarejo.com.br/pt-BR/lojista/categoria/?id=CAT-01025"
        buttonText="Entendi"
        onClick={() => navigate('/step/freight/envvias')}
        imageMobile={ImageMobile}
        image={Image}
        className="cadastro-manual-produtos"
      >
        <Typography as="div" variant="body2">
          Se depois você decidir usar uma integradora,{' '}
          <strong>é só habilitar a integração no Portal do Lojista.</strong>
        </Typography>
      </Panel>
    </Container>
  );
};

export default ProductManualRegistration;
